import { FC, useEffect } from 'react';
import JobsList from '../../components/JobsList/JobsList';
import Tiles from '../../components/Tiles/Tiles';
import Divider from '../../components/Divider';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { authUserSelector } from 'src/store/slices/authUser';
import { useSpinnerContext } from 'src/context/SpinnerContext';
import { isLoadingSelector as isLoadingMetricsSelector } from 'src/store/slices/metrics';
import { clearJobs, isLoadingSelector as isLoadingJobsSelector } from 'src/store/slices/jobs';

export const Dashboard: FC = () => {
  const dispatch = useAppDispatch();
  const authUser = useAppSelector(authUserSelector);
  const { setShowSpinner } = useSpinnerContext();
  const isLoadingMetrics = useAppSelector(isLoadingMetricsSelector);
  const isLoadingjobs = useAppSelector(isLoadingJobsSelector);

  useEffect(() => {
    const isLoading = isLoadingjobs || isLoadingMetrics;
    setShowSpinner(isLoading);
  }, [isLoadingMetrics, isLoadingjobs]);

  useEffect(() => {
    return () => {
      dispatch(clearJobs(undefined));
    };
  }, []);

  if (!authUser) return null;
  return (
    <div className="dm-dashboard inner-content">
      <h2 className="" data-testid="welcome-header">Welcome, {authUser.displayName}</h2>
      <Divider className="my-3" />
      <Tiles />
      <h2 className="mt-3" data-testid="running-jobs-header">Running Jobs </h2>
      <JobsList />
    </div>
  );
};
